import { ApiClientError } from './ApiClientError';

/**
 * 認証エラー
 */
export class UnAuthorizedError extends ApiClientError {
  override name = 'UnAuthorizedError';
}
